// src/components/project/StepSeoMeta.js
import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import FormInput from '../form/FormInput'; 

const StepRoleSeoMeta = ({ control, errors }) => {
    return (
        <div className="animate-fade-in">
            <div className="form-section-title">Search Engine Optimization</div>
            <Row>
                <Col md={6} className="mb-4">
                    <FormInput name="metaTitle"  label="Meta Title"  control={control}  errors={errors}  placeholder="Enter meta title for the project"/>
                </Col>

                <Col md={6} className="mb-4">
                    <FormInput name="metaKeywords"  label="Meta Keywords"  control={control}  errors={errors} placeholder="Enter keywords separated by commas" />
                </Col>

                <Col md={12} className="mb-4">
                    <FormInput name="metaDescription" label="Meta Description"  as="textarea" rows={4} control={control} errors={errors} placeholder="Enter a brief description for search engines" />
                </Col>
            </Row>
        </div>
    );
};

export default StepRoleSeoMeta;